import { delay, Observable, of } from 'rxjs';

// Setting to 1ms to ensure the observable runs in a separate thread. When it was set to 0 the
// registration-list.component.ts was not able initialize the html editor component when the
// event was cached and this observable was used to trigger the get event data response.
export const observableInSeparateThread = <T>(returnedInput: T): Observable<T> => of(returnedInput).pipe(delay(1));
